import { useEffect, useMemo, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { pb } from '../lib/pb';


export default function Search() {
  const [params] = useSearchParams();
  const q = useMemo(() => (params.get('q') || '').trim(), [params]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [products, setProducts] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');
    setProducts([]);
    setProjects([]);
    const doFetch = async () => {
      try {
        if (!q) {
          if (mounted) setLoading(false);
          return;
        }
        const qp = q.replaceAll('"', '\\"');
        const prodFilter = `published=true && (title ~ "%${qp}%" || slug ~ "%${qp}%")`;
        const projFilter = `published=true && (title ~ "%${qp}%" || slug ~ "%${qp}%" || client ~ "%${qp}%" || location ~ "%${qp}%")`;
        const [prods, projs] = await Promise.all([
          pb.collection('products').getList(1, 24, { filter: prodFilter, sort: 'order,title', expand: 'category,extra_categories' }),
          pb.collection('projects').getList(1, 24, { filter: projFilter, sort: '-date,order,title', expand: 'category' })
        ]);
        if (!mounted) return;
        setProducts(prods.items || []);
        setProjects(projs.items || []);
      } catch (e) {
        if (!mounted) return;
        setError(e.message || 'Erreur de recherche');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    doFetch();
    return () => { mounted = false; };
  }, [q]);

  return (
    <>
      <div className="container" style={{ padding: '24px 12px' }}>
        <h1>Recherche</h1>
        {q ? (
          <div style={{ color: '#64748b', marginTop: 4 }}>Résultats pour "{q}"</div>
        ) : (
          <div style={{ color: '#64748b', marginTop: 4 }}>Tapez un terme dans la barre de recherche.</div>
        )}
        {loading && <div style={{ marginTop: 16 }}>Chargement…</div>}
        {error && <div style={{ marginTop: 16, color: 'crimson' }}>{error}</div>}

        {!loading && !error && q && (
          <div style={{ display: 'grid', gap: 24, marginTop: 16 }}>
            <section>
              <h2 style={{ fontSize: 18, marginBottom: 8 }}>Produits ({products.length})</h2>
              {!products.length ? (
                <div className="muted">Aucun produit trouvé.</div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
                  {products.map(p => (
                    <Link key={p.id} to={p.slug ? `/produits/${p.slug}` : '#'} className="admin-card" style={{ padding: 12, textDecoration: 'none' }}>
                      <div style={{ fontWeight: 600, color: '#111827', marginBottom: 4 }}>{p.title}</div>
                      <div className="muted" style={{ fontSize: 12 }}>{p.expand?.category?.name || '—'}</div>
                    </Link>
                  ))}
                </div>
              )}
            </section>

            <section>
              <h2 style={{ fontSize: 18, marginBottom: 8 }}>Réalisations ({projects.length})</h2>
              {!projects.length ? (
                <div className="muted">Aucune réalisation trouvée.</div>
              ) : (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
                  {projects.map(p => (
                    <Link key={p.id} to={p.slug ? `/realisations/${p.slug}` : '#'} className="admin-card" style={{ padding: 12, textDecoration: 'none' }}>
                      <div style={{ fontWeight: 600, color: '#111827', marginBottom: 4 }}>{p.title}</div>
                      <div className="muted" style={{ fontSize: 12 }}>{p.location || p.expand?.category?.name || '—'}</div>
                    </Link>
                  ))}
                </div>
              )}
            </section>
          </div>
        )}
      </div>
    </>
  );
}
